import cartDataNotLoggedHtml from './cartdatanotlogged.component.html';
import './cartdatanotlogged.component.scss';

class CartDataNotLoggedController {
    constructor($scope, CartService, $sce) {
        'ngInject';
        this.$scope = $scope;
        this.service = CartService;
        this.$sce = $sce;
        this.countries = window.countries || ['Polska'];
    }

    $onInit() {
        this.service.step = 2;
        this.$scope.$watch(
            () => {
                if (!this.service.loaded || !this.service.summary) return null;

                return this.service.summary.country;
            },
            (newVal, oldVal) => {
                this.service.data.shipmentAddress.country = newVal;
            }
        );
    }
}

let cartDataNotLoggedComponent = {
    bindings: {},
    template: cartDataNotLoggedHtml,
    controller: CartDataNotLoggedController
}

export default cartDataNotLoggedComponent;